import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { fetchAIScheduleMatrixTableAndFilterSchema } from "model/AIScheduleMatrixModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AIScheduleMatrixContext = createContext();

export const AIScheduleMatrixProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aiScheduleMatrixContextData, setAIScheduleMatrixContextData] =
    useState();

  const fetchAIScheduleMatrixContextData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema(
        "metadata:aiScheduleMatrix",
        () => fetchAIScheduleMatrixTableAndFilterSchema([])
      );
      if (response?.success) {
        setAIScheduleMatrixContextData(response?.data);
      }
    } catch (err) {
      toast.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [fetchMetadataSchema]);

  const value = useMemo(
    () => ({
      fetchAIScheduleMatrixContextData,
      aiScheduleMatrixContextData,
      loading,
      error,
    }),
    [
      fetchAIScheduleMatrixContextData,
      aiScheduleMatrixContextData,
      loading,
      error,
    ]
  );

  return (
    <AIScheduleMatrixContext.Provider value={value}>
      {children}
    </AIScheduleMatrixContext.Provider>
  );
};

export const useAIScheduleMatrixContext = () =>
  useContext(AIScheduleMatrixContext);
